package game

import com.soywiz.korev.Key
import com.soywiz.korio.dynamic.serialization.parseTyped
import com.soywiz.korio.dynamic.serialization.stringifyTyped
import com.soywiz.korio.serialization.json.Json

enum class Language() {
    English,
    French;
}

enum class Keyboard(
    val moveUp1: Key,
    val moveUp2: Key,
    val moveDown1: Key,
    val moveDown2: Key,
    val moveLeft1: Key,
    val moveLeft2: Key,
    val moveRight1: Key,
    val moveRight2: Key,
    val hit1: Key,
    val hit2: Key,
    val menu1: Key,
    val menu2: Key,
    val mute1: Key,
    val mute2: Key,
) {
    Qwerty(
        moveUp1 = Key.W,
        moveUp2 = Key.UP,
        moveDown1 = Key.S,
        moveDown2 = Key.DOWN,
        moveLeft1 = Key.A,
        moveLeft2 = Key.LEFT,
        moveRight1 = Key.D,
        moveRight2 = Key.RIGHT,
        hit1 = Key.SPACE,
        hit2 = Key.ENTER,
        menu1 = Key.ESCAPE,
        menu2 = Key.F10,
        mute1 = Key.M,
        mute2 = Key.MUTE
    ),
    Azerty(
        moveUp1 = Key.Z,
        moveUp2 = Key.UP,
        moveDown1 = Key.S,
        moveDown2 = Key.DOWN,
        moveLeft1 = Key.Q,
        moveLeft2 = Key.LEFT,
        moveRight1 = Key.D,
        moveRight2 = Key.RIGHT,
        hit1 = Key.SPACE,
        hit2 = Key.ENTER,
        menu1 = Key.ESCAPE,
        menu2 = Key.F10,
        mute1 = Key.M,
        mute2 = Key.MUTE
    ),
}

class GameSettings {
    var mute = false
    var muteSteps = false
    var fullScreen = false
    var language = Language.English
    var keyboard = Keyboard.Qwerty
}

suspend fun loadSettings(): GameSettings {
    try {
        val settings = if (fileExists("settings.json")) {
            val strings = loadFile("settings.json")!!

            val mapper = wishlairObjectMapper()

            Json.parseTyped<GameSettings>(strings, mapper)
        } else {
            GameSettings()
        }

        return settings
    } catch (e: Exception) {
        return GameSettings()
    }
}

suspend fun saveSettings(settings: GameSettings) {
    val mapper = wishlairObjectMapper()

    val json = Json.stringifyTyped(settings, mapper, true)

    saveFile("settings.json", json)
}